export enum PermissionAction {
  Create = 'create',
  Read = 'read',
  Update = 'update',
  None = 'none',
}
